import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __assign, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_PROFILE_DATA, USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { calculateConsentGroupState, EGroupCheckboxState } from '@gig/magic-account-types';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';

var ConsentState;
(function (ConsentState) {
    ConsentState["DISALLOWED"] = "OptedOut";
    ConsentState["ALLOWED"] = "Accepted";
})(ConsentState || (ConsentState = {}));
var Consents;
(function (Consents) {
    Consents["EMAIL"] = "isEmailAllowed";
    Consents["SMS"] = "isSMSAllowed";
    Consents["CALL"] = "isCallAllowed";
    Consents["POSTALMAIL"] = "isPostalMailAllowed";
    Consents["NOTIFICATION"] = "isPushNotificationAllowed";
})(Consents || (Consents = {}));
/**
 * Displays a form used to change user marketing preferences.
 * Allows to change all of the communication consents.
 */
var MarketingPreferencesComponent = /** @class */ (function (_super) {
    __extends(MarketingPreferencesComponent, _super);
    function MarketingPreferencesComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.marketingConsents = [];
        _this.isAccordionOpen = {};
        _this.consents = null;
        _this.user = null;
        _this.consentsParams = {};
        _this.Consents = Consents;
        _this.isUKGC = false;
        return _this;
    }
    MarketingPreferencesComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var profileData, _a, consents, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, magic.methods.users.getUserProfile()];
                    case 2:
                        profileData = _b.sent();
                        if (!(profileData === null || profileData === void 0 ? void 0 : profileData.consents)) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.checkIfUKGC()];
                    case 3:
                        _a.isUKGC = _b.sent();
                        if (this.isUKGC) {
                            this.marketingConsents =
                                this.transformProfileToConsents(profileData);
                        }
                        else {
                            consents = profileData.consents;
                            this.consents = {
                                isEmailAllowed: this.isConsentAllowed(consents.emailAllowed),
                                isSMSAllowed: this.isConsentAllowed(consents.smsAllowed),
                                isCallAllowed: this.isConsentAllowed(consents.callAllowed),
                                isPushNotificationAllowed: this.isConsentAllowed(consents.pushNotificationAllowed),
                                isPostalMailAllowed: this.isConsentAllowed(consents.postalMailAllowed),
                            };
                            this.user = profileData.user;
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _b.sent();
                        console.error('Failed to fetch marketing preferences:', error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MarketingPreferencesComponent.prototype.getUserProductMarketingConsents = function (profileData) {
        var _a;
        if (!(profileData === null || profileData === void 0 ? void 0 : profileData.consents)) {
            return {};
        }
        var DEFAULT_STATE = 'NotSet';
        var defaultCategories = {
            casino: {
                callAllowed: DEFAULT_STATE,
                emailAllowed: DEFAULT_STATE,
                postalMailAllowed: DEFAULT_STATE,
                pushNotificationAllowed: DEFAULT_STATE,
                smsAllowed: DEFAULT_STATE,
            },
            sports: {
                callAllowed: DEFAULT_STATE,
                emailAllowed: DEFAULT_STATE,
                postalMailAllowed: DEFAULT_STATE,
                pushNotificationAllowed: DEFAULT_STATE,
                smsAllowed: DEFAULT_STATE,
            },
        };
        var productMarketing = (_a = profileData.consents.productMarketingAllowed) !== null && _a !== void 0 ? _a : {};
        var merged = __assign({}, defaultCategories);
        for (var _i = 0, _b = Object.keys(productMarketing); _i < _b.length; _i++) {
            var key = _b[_i];
            merged[key] = __assign(__assign({}, defaultCategories[key]), productMarketing[key]);
        }
        return merged;
    };
    MarketingPreferencesComponent.prototype.transformProfileToConsents = function (profileData) {
        var _this = this;
        var categories = this.getUserProductMarketingConsents(profileData);
        var keyMap = {
            emailAllowed: {
                name: Consents.EMAIL,
                header: this.getProductMarketingConsentTranslation('EMAIL'),
            },
            smsAllowed: {
                name: Consents.SMS,
                header: this.getProductMarketingConsentTranslation('SMS'),
            },
            callAllowed: {
                name: Consents.CALL,
                header: this.getProductMarketingConsentTranslation('CALL'),
            },
            postalMailAllowed: {
                name: Consents.POSTALMAIL,
                header: this.getProductMarketingConsentTranslation('POSTALMAIL'),
            },
            pushNotificationAllowed: {
                name: Consents.NOTIFICATION,
                header: this.getProductMarketingConsentTranslation('NOTIFICATION'),
            },
        };
        var commonConsentFields = {
            consentId: 0,
            isMandatory: false,
            version: '',
            consentContents: {
                content: '',
                header: '',
                languageAlpha2Code: '',
            },
        };
        return Object.entries(categories).map(function (_a) {
            var category = _a[0], items = _a[1];
            var subConsents = Object.entries(items).map(function (_a) {
                var key = _a[0], value = _a[1];
                console.log({ key: key, value: value });
                var mapped = keyMap[key] || { name: key, header: key };
                return __assign({ name: mapped.name, header: mapped.header, consented: value === 'Accepted' }, commonConsentFields);
            });
            return {
                name: category,
                header: category === 'casino'
                    ? _this.$t('product-marketing-preferences.casino.title')
                    : _this.$t('product-marketing-preferences.sports.title'),
                consented: subConsents.every(function (c) { return c.consented; }),
                subConsents: subConsents,
            };
        });
    };
    MarketingPreferencesComponent.prototype.isConsentAllowed = function (state) {
        return state === ConsentState.ALLOWED;
    };
    MarketingPreferencesComponent.prototype.toggleConsentValues = function (consent) {
        var _a, _b, _c, _d, _e;
        switch (consent) {
            case Consents.EMAIL:
                return !((_a = this.consents) === null || _a === void 0 ? void 0 : _a.isEmailAllowed);
            case Consents.SMS:
                return !((_b = this.consents) === null || _b === void 0 ? void 0 : _b.isSMSAllowed);
            case Consents.CALL:
                return !((_c = this.consents) === null || _c === void 0 ? void 0 : _c.isCallAllowed);
            case Consents.POSTALMAIL:
                return !((_d = this.consents) === null || _d === void 0 ? void 0 : _d.isPostalMailAllowed);
            case Consents.NOTIFICATION:
                return !((_e = this.consents) === null || _e === void 0 ? void 0 : _e.isPushNotificationAllowed);
            default:
                return false;
        }
    };
    MarketingPreferencesComponent.prototype.updatePreferences = function (consent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isUKGC) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateUKGCPreferences(consent)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.updateNonUKGCPreferences(consent)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MarketingPreferencesComponent.prototype.updateNonUKGCPreferences = function (consent) {
        return __awaiter(this, void 0, void 0, function () {
            var consented;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        consented = this.toggleConsentValues(consent);
                        this.consentsParams = (_a = {},
                            _a[consent] = consented,
                            _a.user = __assign({}, this.user),
                            _a);
                        return [4 /*yield*/, magic.methods.users.updateUserProfile(this.consentsParams)];
                    case 1:
                        _b.sent();
                        if (!(consent === Consents.NOTIFICATION)) return [3 /*break*/, 3];
                        return [4 /*yield*/, magic.methods.users.setUserOnSiteMarketing(this.consentsParams.isPushNotificationAllowed)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MarketingPreferencesComponent.prototype.getGroupState = function (consent) {
        return calculateConsentGroupState(consent.subConsents);
    };
    MarketingPreferencesComponent.prototype.isGroupChecked = function (consent) {
        return this.getGroupState(consent) === EGroupCheckboxState.CHECKED;
    };
    MarketingPreferencesComponent.prototype.isGroupIndeterminate = function (consent) {
        return (this.getGroupState(consent) === EGroupCheckboxState.INDETERMINATE);
    };
    MarketingPreferencesComponent.prototype.toggleAccordionState = function (state, category) {
        this.$set(this.isAccordionOpen, category, state);
    };
    MarketingPreferencesComponent.prototype.toggleGroup = function (consent) {
        return __awaiter(this, void 0, void 0, function () {
            var newState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newState = !this.isGroupChecked(consent);
                        consent.subConsents.forEach(function (sub) { return (sub.consented = newState); });
                        return [4 /*yield*/, this.updatePreferences(consent)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MarketingPreferencesComponent.prototype.toggleSubConsent = function (consent, subConsent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subConsent.consented = !subConsent.consented;
                        return [4 /*yield*/, this.updatePreferences(consent)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MarketingPreferencesComponent.prototype.updateUKGCPreferences = function (consent) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedCategory, updatedValues, fullPayload, _i, _a, category, subValues, _b, _c, sub, updatePayload, error_2, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        updatedCategory = consent.name;
                        updatedValues = consent.subConsents.reduce(function (accumulator, subConsent) {
                            accumulator[subConsent.name] = subConsent.consented;
                            return accumulator;
                        }, {});
                        fullPayload = {};
                        for (_i = 0, _a = this.marketingConsents; _i < _a.length; _i++) {
                            category = _a[_i];
                            subValues = {};
                            for (_b = 0, _c = category.subConsents; _b < _c.length; _b++) {
                                sub = _c[_b];
                                subValues[sub.name] = sub.consented;
                            }
                            fullPayload[category.name] = subValues;
                        }
                        fullPayload[updatedCategory] = updatedValues;
                        updatePayload = {
                            isProductMarketingAllowed: fullPayload,
                        };
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, magic.methods.users.updateUserProfile(updatePayload)];
                    case 2:
                        _f.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _f.sent();
                        console.error('Failed to update marketing preferences:', error_2);
                        _d = this;
                        _e = this.transformProfileToConsents;
                        return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 4:
                        _d.marketingConsents = _e.apply(this, [_f.sent()]);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MarketingPreferencesComponent.prototype.checkIfUKGC = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jurisdiction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        jurisdiction = _a.sent();
                        return [2 /*return*/, jurisdiction === Jurisdiction.UKGC];
                }
            });
        });
    };
    MarketingPreferencesComponent.prototype.getConsentTranslation = function (key) {
        var translationKeys = {
            EMAIL: 'marketing-preferences.email.text',
            SMS: 'marketing-preferences.sms.text',
            CALL: 'marketing-preferences.call.text',
            POSTALMAIL: 'marketing-preferences.postal-mail.text',
            NOTIFICATION: 'marketing-preferences.push-notification.text',
        };
        return this.$t(translationKeys[key]);
    };
    MarketingPreferencesComponent.prototype.getProductMarketingConsentTranslation = function (key) {
        var translationKeys = {
            EMAIL: 'product-marketing-preferences.email.text',
            SMS: 'product-marketing-preferences.sms.text',
            CALL: 'product-marketing-preferences.call.text',
            POSTALMAIL: 'product-marketing-preferences.postal-mail.text',
            NOTIFICATION: 'product-marketing-preferences.push-notification.text',
        };
        return this.$t(translationKeys[key]);
    };
    MarketingPreferencesComponent = __decorate([
        Component({
            name: 'corex-marketing-preferences',
        })
    ], MarketingPreferencesComponent);
    return MarketingPreferencesComponent;
}(Mixins(MagicConfigMixin)));

export default MarketingPreferencesComponent;
export { Consents };
